import { render, staticRenderFns } from "./DashboardLendingByMonth.vue?vue&type=template&id=0b674735"
import script from "./DashboardLendingByMonth.vue?vue&type=script&lang=js"
export * from "./DashboardLendingByMonth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports